import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CampaginTable from '../../common/CampaignTable';
import { useState } from 'react';
import axios from 'axios';
import IResponse from '../../../interfaces/response';
import { ICampaign } from '../../../interfaces/campaign';

const CategoryCampagin = () => {
	let { t } = useTranslation();
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [data, setData] = useState<any | null>(null);
	const [modalTitle, setModalTitle] = useState<string>('');
	const headerClassNames = 'text-xs bg-background-paper';
	let tabItem = [
		{
			api: '/admin/options/category',
			postApi: '/admin/options',
			system_name: 'category',
			label: 'create_campaign_category',
			clickAction: () => {
				setOpenModal(!openModal);
				setModalTitle('ایجاد دسته بندی کمپین');
			},
			viewAction: (id: number) => {
				axios<IResponse<ICampaign[]>>({
					url: tabItem[0].api && tabItem[0].api,
				}).then(res => {
					if (res.data.success) {
						const data = res.data.data;
						let filterData = data?.find(item => Number(item.id) === id);
						setData({
							id: id,
							title: filterData?.title,
							check: filterData?.is_active,
							action: 'show',
						});
					}
				});
				setOpenModal(!openModal);
			},
			editAction: (id: number) => {
				axios<IResponse<ICampaign[]>>({
					url: tabItem[0].api && tabItem[0].api,
				}).then(res => {
					if (res.data.success) {
						const data = res.data.data;
						let filterData = data?.find(item => Number(item.id) === id);
						setData({
							id: id,
							title: filterData?.title,
							check: filterData?.is_active,
							action: 'edit',
						});
					}
				});
				setOpenModal(!openModal);
				setModalTitle('ویرایش دسته بندی کمپین');
			},
			showBtn: true,
			view: false,
			edit: true,
			delete: true,
			columns: [
				{ field: 'title', flex: 1, headerName: t('title'), headerAlign: 'center', align: 'center', headerClassName: headerClassNames },
				{
					field: 'created_at',
					flex: 1,
					headerName: t('created_time'),
					headerAlign: 'center',
					align: 'center',
					headerClassName: headerClassNames,
					renderCell: (params: any) => {
						return new Date(params.row.created_at).toLocaleDateString('fa-IR');
					},
				},
				{
					field: 'status',
					headerName: t('status'),
					width: 150,
					flex: 1,
					display: 'flex',
					headerClassName: `${headerClassNames}`,
					headerAlign: 'center',
					align: 'center',
					renderCell: (params: any) => {
						return <div className={`rounded-lg p-2.5 ${params.row.is_active ? 'bg-green-50 text-green-600' : 'bg-red-100 text-red-600'}`}>{params.row.is_active ? t('active') : t('inactive')}</div>;
					},
				},
			],
			route: 'campaigns/view',
		},
	];
	return (
		<Box className="w-full">
			<CampaginTable tabItem={tabItem[0]} dataEdit={data} setOpenModal={setOpenModal} openModal={openModal} modalTitle={modalTitle} />
		</Box>
	);
};

export default CategoryCampagin;
